import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 25 25",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ui-components/comboboxes/*/menu-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-up",
    transform: "translate(7.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.291666645 5.62500001 5.5 0.416666658 10.7083334 5.62500001"
  })))));
});